module.exports = __webpack_public_path__ + "img/Apfelmassaker.21b20331.svg";